import { CustomFieldResourceType } from "@repo/app-types/entities/customField";
import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import { useAllUserCustomFieldDefinitionsQuery } from "../../../api/entities/userCustomField.js";
import { useIsFeatureFlagEnabled } from "../../../helpers/featureFlags/hooks.js";

/**
 * Whether the "Customer interaction" custom field resource type should be
 * offered in the UI. This is the inverse of the interview/"Hire" gating.
 */
export function useShouldShowCustomerInteractionResourceType(): boolean {
  const isRecruitingEnabled = !useIsFeatureFlagEnabled(
    FeatureFlagKey.HideHireTab,
  );
  const { data: customFields } = useAllUserCustomFieldDefinitionsQuery();

  const hasExistingGradingField = (customFields ?? []).some(
    (field) => field.resource_type === CustomFieldResourceType.GRADING,
  );

  return !isRecruitingEnabled || hasExistingGradingField;
}
